import ChooseCategory from "../components/CreateAuctionListingForm/ChooseCategory";
import Container from "../components/layout/Container";
import OtherClassifiedCustomForm from "../components/OthersCustomFiledForm/OtherClassifiedCustomForm";
import FilterHeader from "../components/Shared/FilterHeader/FilterHeader";
import MyAccount from "../components/Shared/MyAccount/MyAccount";

const OthersClassifiedCustomForm = () => {
  return (
    <Container>
      <div className="flex items-start justify-between gap-x-6">
        <MyAccount />
        <div className="grow">
          <FilterHeader
            title={"CREATE CLASSIFIED ADS LISTING"}
            dropdown={false}
            className="mt-[60px]"
          />
          <ChooseCategory />
          <OtherClassifiedCustomForm />
        </div>
      </div>
    </Container>
  );
};

export default OthersClassifiedCustomForm;
